<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>盘库订单</h4>
    </div> -->
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
        <el-form-item label="盘库单号:">
          <el-input type="text" v-model="formData.inventoryNo" style="width:175px;vertical-align:top;" size="mini" placeholder="请输入盘库单号" ></el-input>
        </el-form-item>
        <el-form-item label="订单状态:">
          <el-select v-model="formData.orderStatus" size="mini" placeholder="请选择订单状态" filterable clearable>
            <el-option v-for="item in orderStatusData" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库名称:">
          <el-select  v-model="formData.organizationName" size="mini"  placeholder="">
            <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantName" :key="val.relTenantCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人:">
          <el-input v-model="formData.createUser " style="width:175px;vertical-align:top;" size="mini" placeholder="请输入创建人" ></el-input>
        </el-form-item>
        <el-form-item label="创建时间:">
          <el-date-picker
            v-model="formData.createTimeStart"
            size="mini"
            type="datetime"
            placeholder="请选择创建时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 175px"
          ></el-date-picker>
          -
          <el-date-picker
            v-model="formData.createTimeEnd"
            size="mini"
            placeholder="请选择创建时间"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 175px"
          ></el-date-picker>
        </el-form-item>
        <br/>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun"  v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi"  >重置</el-button>
          <el-button type="primary" size="mini" @click="addJB"  v-if="btnFlg[1]">新建卷板</el-button>
          <el-button type="primary" size="mini" @click="zuofei"  v-if="btnFlg[2]">作废</el-button>
          <el-button type="primary" size="mini" @click="shanchu"  v-if="btnFlg[3]">删除</el-button>
          <el-button type="primary" size="mini" @click="exportClick"  v-if="btnFlg[4]">导出</el-button>

        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table
      height="100%"
      size="mini"
      border
      center
      bordersize="mini"
      ref="tabref1"
      :data="tableData"
      style="width: 100%"
      class="elTab"
      :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
      highlight-current-row
      @row-click="dianjixuanzhong"
      @selection-change="selectGoods"
    >
      <el-table-column type="selection" align="center" width="60"></el-table-column>
      <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column fixed  width="150" label="操作" align="center">
          <template v-slot='scope'>
            <div>
              <el-button type="text"  v-if="btnFlg[5]" @click="HWclick(scope.$index,scope.row)">货物</el-button>
              <el-button type="text"  v-if="btnFlg[6]" @click="RYclick(scope.$index,scope.row)">人员</el-button>
              <el-button type="text" v-if="btnFlg[7]&&scope.row.chargeOrNot=='是'" @click="FYclick(scope.row)">费用</el-button>
            </div>
          </template>
        </el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="orderStatus" label="订单状态" align="center" width="100"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="inventoryNo" label="盘库单号" align="center" width="220"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" width="220"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="inventoryType" label="盘库类型" align="center" ></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="allnumber" label="总件数" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量" width="120" align="center"></el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" prop="totalFee" label="费用总计" align="center"></el-table-column> -->
      <el-table-column :show-overflow-tooltip="true" prop="orderSource" label="订单来源" width="120" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="120" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeStart" label="盘库开始时间" width="180" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeEnd" label="盘库结束时间" width="180" align="center"></el-table-column>
       <el-table-column width="120" label="付款状态" align="center">
          <template v-slot='scope'>
            <div>
              <span v-if="scope.row.payStatus=='1'">已付款</span>
              <span v-if="scope.row.payStatus=='0'" style="color:red">未付款</span>
            </div>
          </template>
        </el-table-column>
      <el-table-column :show-overflow-tooltip="true" :formatter="emptyFn"  prop="payType" label="付款方式" width="120" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" :formatter="emptyFn"  prop="payPerson" label="付款人" width="120" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" :formatter="emptyFn"  prop="payTime" label="付款时间" width="170" align="center"></el-table-column>
    </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
      ></el-pagination>
    </div>
      <billsDetail v-if="zhangdanDetailVisible" :zhangdanDetailVisible.sync="zhangdanDetailVisible"
      :flag="1" :fkFlag="fkFlag" :inventoryMasterId="inventoryMasterId" @jiaofei="jiaofei"></billsDetail>
  </div>
</template>

<script>
import {
  getInventoryOrderList,
  deleteNoInventoryOrder,
  deleteInventoryOrder,
  finishInventoryList,
  getFeeDetailList
} from '@/api/soc-stock'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn, emptyFn } from '@/utils/getButton'
import billsDetail from '@/views/wms-stock/cangChu/jiesuan/billsDetail.vue'
export default {
  components: { billsDetail },
  data () {
    return {
      emptyFn: emptyFn,
      formData: {
        inventoryNo: '',
        orderStatus: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        createUser: ''
      },
      RKData: [],
      orderStatusData: [
        {
          id: 0,
          name: '待盘库'
        },
        {
          id: 1,
          name: '盘库中'
        },
        {
          id: 2,
          name: '已结束'
        },
        {
          id: 3,
          name: '已作废'
        }
      ],
      h: '500px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      btnArr: [
        '0140010100',
        '0140010200',
        '0140010300',
        '0140010400',
        '0140010500',
        '0140010600',
        '0140010700',
        '0140010800'
      ],
      btnFlg: [],
      xuanzhongArr: null,
      selectList: [],
      warehouseList: [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }],
      zhangdanDetailVisible: false,
      inventoryMasterId: null,
      fkFlag: true
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/HZinventoryOrder')
    this.$set(this.formData, 'organizationName', this.warehouseList[0].relTenantName)
    this.$set(this.formData, 'customerTaxId', localStorage.getItem('tenantTaxpayerNumber'))
    this.chaxun()
  },
  methods: {
    getInventoryOrderList () {
      getInventoryOrderList({
        ...this.formData,
        ...this.pageInfo
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.getInventoryOrderList()
    },
    chongzhi () {
      this.formData = {}
      this.$set(this.formData, 'organizationName ', this.warehouseList[0].relTenantName)
      this.$set(this.formData, 'customerTaxId', localStorage.getItem('tenantTaxpayerNumber'))
      this.chaxun()
    },
    zuofei () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要作废的数据')
      } else if (this.selectList.length > 1) {
        this.$message.error('请选择一条数据操作')
      } else {
        this.$confirm('是否确定作废？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(res => {
          console.log(res)
          deleteNoInventoryOrder({
            inventoryMasterId: this.selectList[0].inventoryMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('作废成功')
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    shanchu () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要删除的数据')
      } else if (this.selectList.length > 1) {
        this.$message.error('请选择一条数据操作')
      } else {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(res => {
          console.log(res)
          deleteInventoryOrder({
            inventoryMasterId: this.selectList[0].inventoryMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('删除成功')
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    panhuo () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要盘货的数据')
      } else if (this.selectList.length > 1) {
        this.$message.error('请选择一条数据操作')
      } else {
        this.$confirm('是否确定盘货完成？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(res => {
          console.log(res)
          finishInventoryList({
            inventoryMasterId: this.selectList[0].inventoryMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('盘货完成')
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    // 选中
    selectGoods (selection) {
      this.selectList = selection
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsCenter + '/wmsApi/exportInventoryOrderList',
        this.formData,
        '盘库订单信息表'
      )
    },
    // 提价panku
    tijiao () {},
    HWclick (index, row) {
      if (row.inventoryType == '建材') {
        this.$router.push({
          name: 'cargoJC',
          query: {
            inventoryMasterId: row.inventoryMasterId
          }
        })
      } else {
        this.$router.push({
          name: 'HZcargo',
          query: {
            inventoryMasterId: row.inventoryMasterId
          }
        })
      }
    },
    RYclick (index, row) {
      this.$router.push({
        name: 'HZpeople',
        query: {
          inventoryMasterId: row.inventoryMasterId
        }
      })
    },
    FYclick (row) {
      if (row.payStatus == '1') {
        this.fkFlag = false
      } else {
        this.fkFlag = true
      }
      getFeeDetailList({ inventoryMasterId: row.inventoryMasterId })
        .then(res => {
          this.zhangdanDetailVisible = true
          this.inventoryMasterId = row.inventoryMasterId
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 缴费成功
    jiaofei () {
      this.zhangdanDetailVisible = false
      this.chaxun()
    },
    addJB () {
      this.$router.push({
        name: 'HZaddJB'
      })
    },
    addJC () {
      this.$router.push({
        name: 'addJC'
      })
    }
  }

}
</script>

<style lang='less' scoped>
.messages{
  font-size:16px;
}
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
</style>
